import PitchModel from './PitchModel';
import StoryModel from './StoryModel';
import TaskModel from './TaskModel';
import PublicationModel from './PublicationModel';
import PublicationSectionModel from './PublicationSectionModel';
import EditionModel from './EditionModel';
import IntegrationModel from './IntegrationModel';

const toLoad = [
  PitchModel,
  StoryModel,
  TaskModel,
  PublicationModel,
  PublicationSectionModel,
  EditionModel,
  IntegrationModel
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
